<template>
  <div>
    <div class="greetings-div">
      <p class="home-p-style">
        Welcome, <br><span class="home-user-name">{{ userDetails.first_name }} {{ userDetails.last_name }}</span>
      </p>
      <div class="app-btn-group">
        <v-btn
          v-if="showAppButton"
          small
          elevation="0"
          style="width: fit-content"
          @click="openNativeApp"
        >
          Go to App
          <v-icon> mdi mdi-download </v-icon>
        </v-btn>
        <install-pwa-android />
        <install-pwa-ios />
      </div>
    </div>
    <div v-if="selectedOrganization.active">
      <v-card
        elevation="0"
        class="py-3 px-3"
        light
      >
        <div class="mt-1">
          <div
            v-if="
              !showCheckInButton &&
                currentPayRule.current_pay_rule_settings !== null
            "
            class="text-center"
          >
            <span v-if="!showCheckInButton">
              <font
                color="gray"
                size="2"
              >{{
                currentPayRule.current_pay_rule_settings.payItem.name
              }}</font>
            </span>
          </div>
          <h1 class="timer-style">
            <check-in-clock ref="checkinClock" />
            <span v-if="isBreakEnabled">
              <span
                v-if="checkBreakTaken === 'started'"
                style="font-size: 14px; color: #666"
              >
                <v-icon
                  color="#949494"
                  size="18"
                > mdi-coffee </v-icon>
                {{ hours }} : {{ minutes }}
              </span>
              <span
                v-if="
                  checkBreakTaken === 'start-break' &&
                    showTotalBreaks &&
                    activeCheckInDetails &&
                    Object.keys(activeCheckInDetails).length > 0
                "
                style="font-size: 12px; color: #666"
              ><v-icon
                 color="#949494"
                 size="18"
               > mdi-coffee </v-icon>
                <span style="font-size: 15px; padding-left: 3px; color: #666">{{
                  calculateBreak
                }}</span>
              </span>
            </span>
          </h1>
          <p
            v-if="!showCheckInButton"
            class="text-center checkin-time"
          >
            <font>Started at </font>{{ formatTime(checkinTimer) }} -
            <font> expected end at </font>{{ formatEndTime(activeCheckInDetails.expected_checkout) }}
          </p>
        </div>
      </v-card>
      <div
        v-if="showCheckInButton"
        class="pb-3"
      >
        <v-btn
          class="btn-style"
          color="#64CA7F"
          elevation="0"
          :disabled="!isOrgAvailable"
          @click="toCheckInPage"
        >
          <v-icon> mdi-account-check-outline </v-icon>
          Check-in
        </v-btn>
      </div>
      <div v-else>
        <v-row>
          <v-col
            :cols="isBreakEnabled ? '9' : '12'"
            :class="isBreakEnabled ? 'pr-1' : ''"
          >
            <v-btn
              class="btn-style"
              color="#EF5350"
              elevation="0"
              @click="toCheckOutPage"
            >
              <v-icon> mdi-account-arrow-right-outline </v-icon>Check-out
            </v-btn>
          </v-col>
          <v-col
            v-if="isBreakEnabled"
            cols="3"
            class="pl-1"
          >
            <v-btn
              class="btn-style"
              color="#FFA726"
              elevation="0"
              :disabled="buttonLoading"
              @click="setBreakTime"
            >
              <v-progress-circular
                v-if="buttonLoading"
                size="25"
                :width="1"
                color="#FFF"
                indeterminate
              />
              <div v-else>
                <span v-if="checkBreakTaken === 'start-break'">
                  <v-icon>mdi-coffee</v-icon>
                </span>
                <span v-if="checkBreakTaken === 'started'">
                  <v-icon>mdi-coffee-off</v-icon>
                </span>
              </div>
            </v-btn>
          </v-col>
          <v-col
            v-if="
              currentPayRule &&
                currentPayRule.next_pay_rule_settings &&
                showOvertimeBtn
            "
          >
            <v-btn
              class="btn-style margin-neg"
              color="green"
              elevation="0"
              @click="toOvertime"
            >
              <v-icon> mdi-account-arrow-right-outline </v-icon>Overtime
            </v-btn>
          </v-col>
          <!-- <span class="timer-p-style">{{ showOvertimeBtn }}</span> -->
        </v-row>
      </div>
      <!-- <v-row class="mt-3">
        <v-col cols="12">
          <v-btn class="home-btn" color="#FFF" elevation="0" @click="toJobsPage()">
            <img src="../../../assets/img/job_icon.png" alt="" width="40px">
            <span>Jobs</span>
          </v-btn>
        </v-col>
        <v-col cols="5" class="pr-1 pt-0">
          <v-btn class="home-btn" color="#FFF" elevation="0" @click="toDocsPage()">
            <img src="../../../assets/img/docs_icon.png" alt="" width="32px">
            <span>Docs</span>
          </v-btn>
        </v-col>
        <v-col cols="7" class="pl-1 pt-0">
          <v-btn class="home-btn" color="#FFF" elevation="0" @click="toTimesheetsPage()">
            <img src="../../../assets/img/time_sheet_icon.png" alt="" width="32px">
            <span>Timesheets</span>
          </v-btn>
        </v-col>
      </v-row> -->
      <v-row
        v-if="
          isOrgAvailable &&
            selectedOrganization.app_user_role === 'site-manager'
        "
        class="pa-3"
      >
        <reports-card />
      </v-row>
      <v-row>
        <work-summary />
      </v-row>
    </div>
    <div v-else>
      <access-denied />
    </div>
    <br>
    <check-in-sheet
      v-if="openCheckinSheet"
      :location-enable-check="locationEnableCheck"
      :check-in-type="'manual'"
      @closed="openCheckinSheet = false"
    />
    <alert-dialog
      v-if="showAlert"
      :title="'⚠️ Check-out Too Early ?'"
      :message="'You have logged less than 15 minutes. If you proceed, the timesheet will be deleted as its considered invalid. Do you want to continue with check-out?'"
      @closed="showAlert = false"
      @confirmed="continueCheckout()"
    />
    <check-out-sheet
      v-if="openCheckOutSheet"
      :location-enable-check="locationEnableCheck"
      @closed="openCheckOutSheet = false"
      @reload="sheetClosed()"
    />
    <center-spinner :loading="loading" />
  </div>
</template>
<script>
import { getTimeZone } from '../../../utils/timezone';
import CheckInClock from './CheckInClock.vue';
import Constants from 'src/constants';
import InstallPwaAndroid from './InstallPwaAndroid.vue';
import InstallPwaIos from './InstallPwaIos.vue';
import WorkSummary from './WorkSummary.vue';
import moment from 'moment';
import CheckInSheet from './CheckInSheet.vue';
import CheckOutSheet from './CheckOutSheet.vue';
import AlertDialog from 'src/views/components/AlertDialog.vue';
import spinner from '../../components/SpinnerCentre.vue';
import ReportsCard from './dialogComponents/reportsDialogs/ReportsCard.vue';
import AccessDenied from '../../components/AccessDenied.vue';
export default {
  name: 'HomePage',
  components: {
    'check-in-clock': CheckInClock,
    'install-pwa-android': InstallPwaAndroid,
    'install-pwa-ios': InstallPwaIos,
    'work-summary': WorkSummary,
    'check-in-sheet': CheckInSheet,
    'check-out-sheet': CheckOutSheet,
    'alert-dialog': AlertDialog,
    'center-spinner': spinner,
    'reports-card': ReportsCard,
    'access-denied': AccessDenied,
  },
  data: () => ({
    loading: false,
    buttonLoading: false,
    hours: null,
    minutes: null,
    seconds: null,
    breakTime: null,
    showOvertimeBtn: false,
    intervalId: null,
    openCheckinSheet: false,
    openCheckOutSheet: false,
    showAlert: false,
    showAppButton: false,
    appConfig: null,
  }),
  computed: {
    userDetails () {
      return this.$store.getters['userprofile/getUserDetails'];
    },
    workLogs () {
      const logs = this.$store.getters['swiftuser/getWorkLogs'];
      return logs;
    },
    dailyReports () {
      return this.$store.getters['swiftuser/getDailyReports'];
    },
    workTimerLastUpdatedAt () {
      return this.$store.getters['swiftuser/getWorkTimerUpdatedAt'];
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    activeCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
    currentPayRule () {
      return JSON.parse(localStorage.getItem('userActiveRecord'));
    },
    isOrgAvailable () {
      if (
        this.selectedOrganization !== null &&
        this.selectedOrganization !== undefined
      ) {
        return true;
      }
      return false;
    },
    orgSettings () {
      return this.$store.getters['organization/getOrganizationSettings'];
    },
    locationEnableCheck () {
      return this.orgSettings.location_verification;
    },
    isBreakEnabled () {
      return (
        this.orgSettings &&
        this.orgSettings.break &&
        this.orgSettings.break.enabled === true
      );
    },
    showCheckInButton () {
      if (Object.keys(this.activeCheckInDetails).length > 0) {
        return false;
      } else {
        return true;
      }
    },
    showTotalBreaks () {
      if (
        this.activeCheckInDetails &&
        Object.keys(this.activeCheckInDetails).length > 0
      ) {
        if (
          this.activeCheckInDetails.break_list &&
          this.activeCheckInDetails.break_list.length > 0
        ) {
          return true;
        } else {
          return 'started';
        }
      } else {
        return 'startNow';
      }
    },
    checkBreakTaken () {
      const details = this.activeCheckInDetails;
      if (
        !details ||
        !Array.isArray(details.break_list) ||
        details.break_list.length === 0
      ) {
        return 'start-break';
      }
      const firstBreak = details.break_list[0];
      if (
        firstBreak &&
        firstBreak.break_start !== null &&
        firstBreak.break_end === null
      ) {
        return 'started';
      }
      if (
        firstBreak &&
        firstBreak.break_start !== null &&
        firstBreak.break_end !== null
      ) {
        return 'start-break';
      }
      return '';
    },

    calculateBreak () {
      const details = this.activeCheckInDetails;
      if (!details || !details.break_list || !details.break_list.length === 0) {
        return null;
      }
      let totalSeconds = 0;

      details.break_list.forEach((b) => {
        const startTime = new Date(b.break_start);
        const endTime = new Date(b.break_end);
        totalSeconds += Math.floor((endTime - startTime) / 1000);
      });

      const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
        2,
        '0',
      );
      return `${hours}:${minutes}`;
    },
    checkinTimer () {
      if (
        this.currentPayRule &&
        this.currentPayRule.app_user &&
        this.currentPayRule.app_user.timesheet_tracking &&
        Array.isArray(this.currentPayRule.all_timesheets) &&
        this.currentPayRule.all_timesheets.length > 0
      ) {
        return this.currentPayRule.all_timesheets[0].actual_start_time;
      } else if (
        this.activeCheckInDetails &&
        this.activeCheckInDetails.checkin_time
      ) {
        return this.activeCheckInDetails.checkin_time;
      }
      return null; // fallback
    },
  },
  watch: {
    workTimerLastUpdatedAt (val) {
      this.fetchActiveCheckInDetails();
    },
  },
  beforeDestroy () {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  async mounted () {
    this.loading = true;
    await this.checkTimezone();
    await this.fetchActiveCheckInDetails();
    await this.fetchUserDetails();
    (await this.isOrgAvailable) && (await this.fetchOrgDetails());
    await this.checkLocalStorage();
    this.$store.dispatch('swiftuser/updateWorkTimer');
    (await this.isOrgAvailable) &&
      (await this.fetchWorkLogsList().then(() => {
        this.setupIntervalForCheckOut();
      }));
    await this.fetchDailyReports();
    await this.isAppInstalled();
    this.loading = false;
  },
  methods: {
    getMobileOS () {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(ua)) return 'Android';
      if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'iOS';
      return 'Other';
    },
    isAppInstalled () {
      const os = this.getMobileOS();
      const data = this.userDetails;

      const config = {
        iOS: {
          deepLink: 'swiftcheckin://open',
          storeLink: 'https://apps.apple.com/app/idYOUR_APP_ID',
        },
        Android: {
          deepLink: 'swiftcheckin://open',
          storeLink:
            'https://play.google.com/store/apps/details?id=com.swiftcheckin.app',
        },
      };

      if (os === 'Other') {
        console.log('Not a mobile device');
        return;
      }

      const appConfig = config[os];

      if (data.app) {
        this.appConfig = appConfig;
        this.showAppButton = true;
      }
    },
    openNativeApp () {
      const start = Date.now();

      window.location.href = this.appConfig.deepLink;

      setTimeout(() => {
        const elapsed = Date.now() - start;

        if (elapsed < 2500) {
          window.location.href = this.appConfig.storeLink;
        }
      }, 2000);
    },
    setupIntervalForCheckOut () {
      if (this.workLogs.length === 0) {
        return;
      }
      this.exceedCheckoutTime();
      this.intervalId = setInterval(() => {
        this.exceedCheckoutTime();
      }, 1000);
    },
    async fetchOrgDetails () {
      this.loading = true;
      await this.$store
        .dispatch(
          'organization/fetchOrganizationSettings',
          this.selectedOrganization,
        )
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async checkTimezone () {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (this.userDetails.timezone === null) {
        await this.$store
          .dispatch('userprofile/updateTimezone', {
            params: {
              timezone: timezone,
            },
          });
      } else if (this.userDetails.timezone !== timezone) {
        this.showTimezoneDialog = true;
      } else {
        this.showTimezoneDialog = false;
      }
    },
    async fetchDailyReports () {
      this.loading = true;
      await this.$store
        .dispatch('organization/fetchDailyReports', this.selectedOrganization)
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async sheetClosed () {
      // this.openCheckinSheet = false;
      // this.openCheckOutSheet = false;
      // await this.fetchUserDetails();
      // await this.fetchActiveCheckInDetails();
      // await this.checkLocalStorage();
      // this.$store.dispatch("swiftuser/updateWorkTimer");
      // await this.fetchWorkLogsList().then(() => {
      //   this.setupIntervalForCheckOut();
      // });
      window.location.reload();
    },
    async fetchActiveCheckInDetails () {
      this.loading = true;
      await this.$store
        .dispatch('swiftuser/fetchUsersCurrentCheckInDetails')
        .then((response) => {
          if (Object.keys(this.activeCheckInDetails).length > 0) {
            const checkInId = this.activeCheckInDetails.id;
            var checkInTime;
            if (
              this.workLogs.length !== 0 &&
              this.workLogs[0].timesheets &&
              this.workLogs[0].timesheets.start_time
            ) {
              checkInTime = +new Date(this.workLogs[0].timesheets.start_time);
            } else {
              checkInTime = +new Date(this.activeCheckInDetails.checkin_time);
            }
            if (
              this.activeCheckInDetails.checkin_method_type !== 'cost-shift'
            ) {
              localStorage.setItem('checkIn', checkInId);
              localStorage.setItem('checkInTime', checkInTime);
              if (this.$refs.checkinClock) {
                this.$refs.checkinClock.setClock();
              }
            }
            this.loading = false;
          } else {
            localStorage.removeItem('checkInTime');
            localStorage.removeItem('checkIn');
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
 async fetchWorkLogsList () {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (this.userDetails.timezone === null) {
        await this.$store.dispatch('userprofile/updateTimezone', {
          params: { timezone },
        });
      }
      this.loading = true;
      await this.$store.dispatch('swiftuser/fetchWorkLogs', {
        externalId: this.selectedOrganization.organization.external_id,
      });
      this.loading = false;
    },
    exceedCheckoutTime () {
      if (this.workLogs.length === 0 || this.showCheckInButton) {
        return;
      }
      const timesheet = this.workLogs && this.workLogs[0].timesheets;
      if (
        timesheet &&
        timesheet.actual_start_time &&
        timesheet.threshold_hours &&
        timesheet.remaining_hours !== '00:00'
      ) {
        const [hoursStr, minsStr] = timesheet.remaining_hours.split(':');
        // threshold hours
        const hours = parseInt(hoursStr, 10);
        const mins = parseInt(minsStr, 10);
        // timestamp
        const timestamp = new Date(timesheet.actual_start_time).getTime();
        const now = Date.now();
        const diffMinutes = Math.floor((now - timestamp) / (1000 * 60));
        const allowedMinutes = hours * 60 + mins;
        this.showOvertimeBtn = diffMinutes >= allowedMinutes;
      } else {
        console.warn('Missing or invalid timesheet data.');
      }
    },

    async toOvertime () {
      var breakTime = localStorage.getItem('breakTime');
      if (breakTime !== null) {
        this.$store.dispatch('alert/onAlert', {
          message: 'Please remove the break before overtime!',
          type: Constants.ALERT_TYPE_INFO,
        });
        return;
      }
      if (
        this.workLogs.length !== 0 &&
        this.workLogs[0].timesheets &&
        this.workLogs[0].timesheets.id
      ) {
        this.loading = true;
        await this.$store
          .dispatch('swiftuser/startOvertime', {
            pay_rule_settings_id: this.currentPayRule.next_pay_rule_settings.id,
            checkInId: this.currentPayRule.id,
          })
          .then(() => {
            this.loading = false;
            this.$store.dispatch('alert/onAlert', {
              message: 'Shifted to overtime successfully!',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.$store
              .dispatch('swiftuser/fetchUsersCurrentCheckInDetails')
              .then(() => {
                window.location.reload();
              });
          });
      } else {
        this.$store.dispatch('alert/onAlert', {
          message: 'Missing timesheet data. Please try again later.',
          type: Constants.ALERT_TYPE_ERROR,
        });
      }
    },
    async fetchUserDetails () {
      this.loading = true;
      await this.$store.dispatch('userprofile/fetchUserDetails');
      this.loading = false;
    },
    toWorkersPage () {
      this.$store.dispatch('alert/onAlert', {
        message: 'Coders at work! We will be coming on the next version.',
        type: Constants.ALERT_TYPE_FEATURE,
      });
    },
    toJobsPage () {
      this.$router.push('/jobs');
    },
    toDocsPage () {
      this.$router.push('/documents');
    },
    toTimesheetsPage () {
      this.$router.push('/timesheets');
    },
    toCheckInPage () {
      this.openCheckinSheet = true;
      // this.$router.push("/check-in");
    },
    toCheckOutPage () {
      // ✅ Check for check-in time
      const checkInTime = localStorage.getItem('checkInTime');
      if (checkInTime) {
        const checkInMs = parseInt(checkInTime, 10);
        const now = Date.now();
        const diffMinutes = (now - checkInMs) / (1000 * 60);

        if (diffMinutes < 15) {
          this.showAlert = true;
          return;
        }
      }
      this.openCheckOutSheet = true;
      // this.$router.push("/check-out");
    },
    continueCheckout () {
      this.showAlert = false;
      this.openCheckOutSheet = true;
    },
    checkLocalStorage () {
      var breakTime = localStorage.getItem('breakTime');
      if (breakTime !== null) {
        this.setClock();
      }
    },
    setBreakTime () {
      this.buttonLoading = true;
      const recordId = this.activeCheckInDetails.id;
      const breakType =
        this.checkBreakTaken === 'start-break' ? 'break_start' : 'break_end';
      this.$store
        .dispatch('timesheets/takeBreakTime', {
          checkinRecordId: recordId,
          details: {
            break_type: breakType,
          },
        })
        .then(() => {
          this.$store
            .dispatch('swiftuser/fetchUsersCurrentCheckInDetails')
            .then(() => {
              this.buttonLoading = false;
              if (breakType === 'break_start') {
                this.setClock();
              } else {
                localStorage.removeItem('breakTime');
              }
            });
        })
        .catch(() => {
          this.buttonLoading = false;
        });
    },
    setClock () {
      var breakTime = localStorage.getItem('breakTime');
      if (breakTime === null) {
        var startTime = +new Date();
        localStorage.setItem('breakTime', startTime);
        this.$store.dispatch('swiftuser/updateBreakTimer');
        this.breakTime = new Date(startTime).toISOString();
        setInterval(this.startClock, 1000);
        return;
      }
      var parsedBreakTime = JSON.parse(breakTime);
      this.breakTime = new Date(parsedBreakTime).toISOString();
      this.$store.dispatch('swiftuser/updateBreakTimer');
      setInterval(this.startClock, 1000);
    },
    startClock () {
      var breakTime = localStorage.getItem('breakTime');
      var parsedBreakTime = JSON.parse(breakTime);
      var updatedTime = +new Date();
      this.difference = updatedTime - parsedBreakTime;
      var hours = Math.floor(
        (this.difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      var minutes = Math.floor(
        (this.difference % (1000 * 60 * 60)) / (1000 * 60),
      );
      var seconds = Math.floor((this.difference % (1000 * 60)) / 1000);

      this.hours = hours < 10 ? '0' + hours : hours;
      this.minutes = minutes < 10 ? '0' + minutes : minutes;
      this.seconds = seconds < 10 ? '0' + seconds : seconds;
    },
    formatTime (utcTime) {
      const localTime = moment.utc(utcTime).local();
      if (localTime.isSame(moment(), 'day')) {
        return `${localTime.format('h:mm A')}`;
      } else {
        return localTime.format('Do MMM YYYY [at] h:mm A');
      }
    },
    formatEndTime (utcTime) {
      const localTime = moment.utc(utcTime).local();
      if (localTime.isSame(moment(), 'day')) {
        return `${localTime.format('h:mm A')}`;
      } else {
        return localTime.format('Do MMM YYYY [at] h:mm A');
      }
    },
  },
};
</script>
<style scoped>
.v-card__actions {
  position: relative;
  display: flex;
  gap: 20px;
  overflow-x: scroll;
  box-shadow: inset 10px 0 5px -5px rgba(0, 0, 0, 0.08),
    inset -10px 0 5px -5px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
}

.app-btn-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.v-card__actions::-webkit-scrollbar {
  display: none;
}

.home-btn {
  text-transform: capitalize !important;
}

.btn-style span {
  color: #fff;
}

.btn-style.v-btn.v-btn--disabled {
  opacity: 1 !important;
  background-color: #96cfa5 !important;
  color: white !important;
  cursor: not-allowed !important;
  pointer-events: auto !important;
}

.badge {
  background: green;
  color: #fff;
  border-radius: 10px;
  padding: 0px 10px;
}

.margin-neg {
  margin-top: -12px;
  font-weight: 200 !important;
  font-size: 12px;
}

.checkin-time {
  color: #989898;
  font-size: 12px;
}
</style>
